import React, { useState } from "react";
import clsx from "clsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { Collapse, makeStyles } from "@material-ui/core";
import { color, motion } from "framer-motion";
import Link from "../../components/v2/Link";
import LazyImage from "../../components/v4/LazyLoadImage/LazyImage";
import AllCountries from "../../components/v4/AllCountries/AllCountries";
import TestimonialSlider from "../../components/v3/TestimonialSlider/TestimonialSlider";
import FaqSection from "../../components/v4/FaqSection/FaqSection";
import TruestedSection from "../../components/v4/TrustedSection/TruestedSection";

import whiteCheckCircle from "../../images/v4/whatsappPage/icons/whiteCheckCircle.svg";
import greenCheckCircle from "../../images/v4/whatsappPage/icons/greenCheckCircle.svg";
import downArrow from "../../images/v4/aiPage/icons/downArrow.svg";
import bodySectionBg from "../../images/v4/industry/education/images/bodySectionBg.png";
import industryHeroSectionBg from "../../images/v4/industry/education/images/industryHeroSectionBg.png";

import india from "../../images/v4/country/india/icons/india.svg";

import bestIcon1 from "../../images/v4/country/india/icons/bestIcon1.svg";
import bestIcon2 from "../../images/v4/country/india/icons/bestIcon2.svg";
import bestIcon3 from "../../images/v4/country/india/icons/bestIcon3.svg";
import bestIcon4 from "../../images/v4/country/india/icons/bestIcon4.svg";
import bestIcon5 from "../../images/v4/country/india/icons/bestIcon5.svg";

import smartIcon1 from "../../images/v4/country/india/icons/smartIcon1.svg";
import smartIcon2 from "../../images/v4/country/india/icons/smartIcon2.svg";
import smartIcon3 from "../../images/v4/country/india/icons/smartIcon3.svg";
import smartIcon4 from "../../images/v4/country/india/icons/smartIcon4.svg";
import smartIcon5 from "../../images/v4/country/india/icons/smartIcon5.svg";
import smartIcon6 from "../../images/v4/country/india/icons/smartIcon6.svg";
import smartIcon7 from "../../images/v4/country/india/icons/smartIcon7.svg";
import smartIcon8 from "../../images/v4/country/india/icons/smartIcon8.svg";
import smartIcon9 from "../../images/v4/country/india/icons/smartIcon9.svg";

import partnerIcon1 from "../../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../../images/v4/aiPage/icons/partnerIcon8.png";

import compareItemImg1 from "../../images/v4/industry/education/images/compareItemImg1.png";
import compareItemImg2 from "../../images/v4/industry/education/images/compareItemImg2.png";
import compareItemImg3 from "../../images/v4/industry/education/images/compareItemImg3.png";
import compareItemImg4 from "../../images/v4/industry/education/images/compareItemImg4.png";
import compareItemImg5 from "../../images/v4/industry/education/images/compareItemImg5.png";

import countryBackground from "../../images/v4/country/india/images/countryBackground.webp";
import benefitImg from "../../images/v4/country/india/images/benefitImg.png";

import realWorldImg1 from "../../images/v4/country/india/images/realWorldImg1.png";
import realWorldImg2 from "../../images/v4/country/india/images/realWorldImg2.png";
import realWorldImg3 from "../../images/v4/country/india/images/realWorldImg3.png";
import realWorldImg4 from "../../images/v4/country/india/images/realWorldImg4.png";
import SEO from "../../components/SEO";

const useStyles = makeStyles((theme) => ({
  heroSection: {
    background: `url(${industryHeroSectionBg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "top",
    padding: "100px 0 60px",
    "& .countryHighlight": {
      background: "linear-gradient(99deg, #208EEC 5.93%, #00B661 95.25%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "16px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      "& .buttonContaienr": {
        justifyContent: "center",
      },
      "@media only screen and (max-width: 600px)": {
        width: "100%",
        marginTop: "0px",
        "& .buttonContaienr": {
          alignItems: "center",
        },
        "& .primaryButton": {
          width: "100%",
        },
        "& .countryLogo": {
          width: "30px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0",
    },
  },
  listContainer: {
    display: "flex",
    marginTop: "16px",
    // flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "100%",
      gap: "15px",
    },
  },
  listItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    border: "1px solid #00B661",
    borderRadius: "50px",
    padding: "10px 15px",
    minWidth: "max-content",
    "@media only screen and (max-width: 600px)": {
      minWidth: "90%",
    },
    // color: "#A2BED3",
  },
  compareSection: {
    position: "relative",
    paddingTop: "200px",
    paddingBottom: "80px",
    "& $supportBox": {
      position: "absolute",
      top: "-410px",
      background: "linear-gradient(0deg, #7C35B5 0%, #672A99 100%)",
    },
    "& .header": {
      width: "70%",
      margin: "0 auto",
      textAlign: "center",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "540px",
      "& $supportBox": {
        top: "-770px",
      },
      "& .header": {
        width: "100%",
      },
    },
  },
  compareSectionLeftItem: {
    padding: "15px 20px",
    borderLeft: "5px solid transparent",
    transition: "0.3s ease",
    "&.active": {
      borderLeft: "5px solid #02AE7F",
    },
    "& a": {
      textDecoration: "none",
      color: "#000",
    },
  },
  compareSectionContainer: {
    gap: "40px",
    display: "flex",
    marginTop: "60px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    "@media only screen and (max-width: 768px)": {
      flexDirection: "column",
      marginTop: "30px",
      gap: "20px",
    },
  },
  compareSectionContainerLeftSection: {
    width: "30%",
    position: "sticky",
    top: "100px",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
      position: "static",
      display: "none",
    },
  },
  compareSectionContainerRightSection: {
    width: "70%",
    "@media only screen and (max-width: 768px)": {
      width: "100%",
    },
  },
  compareItemContainer: {
    marginBottom: "60px",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    flexDirection: "column",
    gap: "20px",
    "& .productImage": {
      width: "100%",
    },
    "&:last-child": {
      marginBottom: 0,
    },
  },
  faqsContainer: {
    marginTop: "60px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    cursor: "pointer",
    width: "100%",
    "@media only screen and (max-width: 768px)": {
      marginTop: 0,
    },
  },
  faqBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    borderBottom: "1px solid #B7B7B7",
    width: "100%",
    "&:first-child": {
      borderTop: "1px solid #B7B7B7",
      paddingTop: "15px",
    },
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      "& h3": {
        textAlign: "left",
      },
    },
  },
  downArrow: {
    transition: "0.3s ease",
    "&.active": {
      transform: "rotate(180deg)",
    },
  },
  body: {
    textAlign: "left",
    margin: "10px 0 15px",
  },
  partnerSlide: {
    width: "185px !important",
    "& img": {
      width: "185px",
      filter: "brightness(0.1)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "140px !important",
      marginRight: "30px !important",
      "& img": {
        width: "140px",
        filter: "brightness(0.1)",
      },
    },
  },
  partnerSlider: {
    padding: "10px 0 40px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  stripSection: {
    backgroundColor: "#e9f4fe",
    // backgroundImage: `url(${partnerSectionBackground})`,
    backgroundPosition: "top",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "& .centerContainer": {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        textAlign: "center",
      },
    },
  },
  testimonials: {
    background: "#e9f4fe",
  },
  wpFaq: {
    padding: "40px 0",
    background: "#eaffff",
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 0 !important",
      },
    },
  },
  commonPageFooterSection: {
    background: "linear-gradient(to right, #011d32 -1%, #00182b 100%)",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  growingBusiness: {
    backgroundImage: `url(${bodySectionBg})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    paddingBottom: "300px",
    position: "relative",
    "& .header": {
      width: "50%",
      textAlign: "left",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
    },
    "& .body": {
      width: "100%",
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "stretch",
      gap: "20px",
      flexWrap: "wrap",
      marginTop: "60px",
    },
    "& $featureContainer": {
      gap: "20px",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "0 0 300px",
      "& .header": {
        width: "100%",
      },
    },
    "& $broadcastLeftContainer": {
      width: "55%",
    },
  },
  practiceCard: {
    background: "#ffffff1a",
    borderRadius: "16px",
    padding: "24px",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column",
    gap: "16px",
    width: "32%",
    opacity: "1",
    backdropFilter: "blur(30px) brightness(1)",
    transition: "0.3s ease",
    "&:hover": {
      backdropFilter: "blur(50px) brightness(1.2)",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  countrySection: {
    padding: "60px 0",
    borderRadius: "40px 40px 0 0",
    backgroundImage: `url(${countryBackground})`,
    backgroundSize: "cover",
    "& .header": {
      width: "60%",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .cards": {
      display: "flex",
      width: "100%",
      justifyContent: "flex-start",
      gap: "20px",
      alignItems: "stretch",
      marginTop: "60px",
      "@media only screen and (max-width: 600px)": {
        flexDirection: "column",
        marginTop: "40px",
      },
    },
    "& .card": {
      padding: "32px 24px",
      borderRadius: "16px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      gap: "32px",
      backdropFilter: "blur(20px)",
      border: "1px solid #534B69 ",
      width: "48%",
      background:
        "linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      padding: "0",
    },
  },
  tabsSection: {
    background: "#FFF9F0",
    paddingTop: "280px",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "& $supportBox": {
      position: "absolute",
      top: "-530px",
      "@media only screen and (max-width: 600px)": {
        top: "-800px",
        marginTop: 0,
      },
    },
    "@media only screen and (max-width: 600px)": {
      paddingTop: "550px",
      "& .centerContainer": {
        width: "100%",
      },
    },
  },
  tabsContainer: {
    width: "80%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px",
    border: "2px solid #DBDBDB",
    borderRadius: "40px",
    background: "#fff",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "10px",
      padding: "5px",
      overflow: "auto",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
  },
  tab: {
    width: "33%",
    background: "",
    padding: "18px",
    background: "transparent",
    borderRadius: "40px",
    background: "transparent",
    transition: "0.3s ease",
    cursor: "pointer",
    "&.active": {
      color: "white",
      background:
        "linear-gradient(90deg, #FF682A 0%, #FF7056 35%, #FF682A 73%, #FF550F 100%)",
    },
    "@media only screen and (max-width: 600px)": {
      minWidth: "max-content",
      padding: "10px 15px",
    },
  },
  tabCard: {
    marginTop: "20px",
    gap: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "@media only screen and (max-width: 600px)": {
      marginTop: "30px",
      flexDirection: "column",
    },
  },
  tabCardLeftContainer: {
    width: "50%",
    display: "flex",
    gap: "40px",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      gap: "20px",
      width: "100%",
    },
  },
  benfitListContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "30px",
    marginTop: "50px",
    "@media only screen and (max-width: 600px)": {
      gap: "15px",
      marginTop: "20px",
    },
  },
  benfitListItem: {
    display: "flex",
    width: "100%",
    margin: "0 auto",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "15px",
    position: "relative",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      alignItems: "flex-start",
    },
  },
  benfitListItemContent: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "10px",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  tabCardRightContainer: {
    width: "50%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  benfitIcon: {
    position: "relative",
    top: "5px",
  },
  supportBox: {
    top: "100%",
    width: "100%",
    display: "flex",
    padding: "40px",
    background: "linear-gradient(180deg, #208EEC -2.28%, #002C51 134.12%)",
    position: "relative",
    alignItems: "center",
    borderRadius: "20px",
    backdropFilter: "blur(30px)",
    justifyContent: "space-between",
    "& $broadcastLeftContainer": {
      width: "55%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      width: "94%",
      padding: "15px",
      marginTop: "20px",
      gap: "20px",
    },
  },
  pointers: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "20px",
  },
  cardPointer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    gap: "15px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "center",
    },
  },
  broadcastLeftContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "60%",
    gap: "32px",
    textAlign: "left",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "20px",
    },
  },
  broadcastRightContainer: {
    width: "40%",
    "& img": {
      width: "100%",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      "& img": {
        width: "100%",
      },
    },
  },
  broadcastImg: {
    "& img": {
      width: "100%",
      position: "relative",
      bottom: "0",
    },
  },
  adaptFeatures: {
    backgroundrepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${industryHeroSectionBg})`,
    "& .header": {
      display: "flex",
      width: "55%",
      gap: "10px",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
      textAlign: "left",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .container": {
      paddingBottom: "35px",
    },
  },
  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 65px",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 65px",
    },
  },
  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "space-between",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptBoxHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "16px",
  },
}));

const India = () => {
  const classes = useStyles();
  const [activeCompare, setActiveCompare] = useState("#section0");
  const [activeAccordian, setActiveAccordian] = useState(0);
  const [activeRealWorld, setActiveRealWorld] = useState(0);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 100; // Height of navigation bar
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];
  const faqs = [
    {
      question: "Which is the best CRM software in India for small businesses?",
      answer: (
        <>
          Pepper Cloud CRM is designed specifically for SMEs in India with
          affordable pricing and essential features.
        </>
      ),
    },
    {
      question: "How to get a CRM for your growing business in India?",
      answer: (
        <>
          Getting started with the best CRM software in India is quick and
          hassle-free. Whether you’re a startup or a scaling enterprise, Pepper
          Cloud CRM helps you manage leads, sales, and customer relationships
          seamlessly.
          <ul>
            <li>
              Book a free demo and explore Pepper Cloud CRM with a personalised
              walkthrough.
            </li>
            <li>
              Connect with our India CRM experts to find the right plan and
              feature set for your business.
            </li>
            <li>Set up your account easily—no setup fees, no complexity.</li>
            <li>
              Customise your CRM to match your sales workflows, pipelines, and
              automation needs.
            </li>
            <li>
              Go live and scale faster with AI-powered tools designed for Indian
              businesses.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How to choose the best CRM for your Indian business",
      answer: (
        <>
          <ul>
            <li>
              Scalability: Opt for a CRM that grows with your
              business—supporting expanding teams, leads, and customer data
              effortlessly.
            </li>
            <li>
              Customisation: Choose a CRM that adapts to your unique industry
              needs, sales pipelines, and business workflows.
            </li>
            <li>
              Integration capabilities: Ensure smooth integration with your
              existing tools like WhatsApp, Google Workspace, and marketing
              platforms.
            </li>
            <li>
              Local support: Go for a provider with dedicated support in India
              to ensure timely assistance and smoother onboarding.
            </li>
            <li>
              Affordable pricing: Look for a CRM that offers transparent,
              value-driven pricing with no hidden costs—perfect for growing
              Indian businesses.
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "How do I choose a CRM?",
      answer: (
        <>
          Choosing the right CRM for your business involves understanding your
          needs and the features that best support your growth. Start by
          considering:
          <ul>
            <li>
              Scalability: Ensure the CRM can grow with your business and handle
              increasing data and team size.
            </li>
            <li>
              Customisation: Look for a CRM that allows you to tailor workflows,
              pipelines, and dashboards to fit your business processes.
            </li>
            <li>
              Integration: Choose a CRM that integrates seamlessly with your
              existing tools like WhatsApp, email, Google Workspace, and social
              media platforms.
            </li>
            <li>
              User-Friendliness: A simple, intuitive interface is key for
              ensuring your team adopts the system easily.
            </li>
            <li>
              Support: Ensure the CRM offers local support for quick
              troubleshooting and effective onboarding.
            </li>
          </ul>
          Pepper Cloud CRM, the best CRM software in India, offers all these
          features and more to help you streamline operations, improve customer
          engagement, and drive growth.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM suitable for Indian startups?",
      answer: (
        <>
          Absolutely. It is scalable, easy to set up, and comes with automation
          to help startups grow faster.
        </>
      ),
    },
    {
      question: "Can I integrate Pepper Cloud CRM with my current tools?",
      answer: (
        <>
          Yes, it supports email, forms, calendars, and{" "}
          <a href="https://peppercloud.com/crm-integrations" target="_blank">
            third-party tools integration
          </a>
          .
        </>
      ),
    },
    {
      question: "How secure is Pepper Cloud CRM?",
      answer: (
        <>
          It uses multi-layered security protocols to protect your customer data
          and ensure compliance.
        </>
      ),
    },
    {
      question: "Which CRM is most used in India?",
      answer: (
        <>
          While many global CRMs are used in India, Pepper Cloud CRM is rapidly
          becoming the preferred choice for Indian SMEs due to its user-friendly
          interface, affordability, and features tailored for local business
          needs—like WhatsApp integration, lead tracking, and regional support.
        </>
      ),
    },
    {
      question: "Is Pepper Cloud CRM costly?",
      answer: (
        <>
          Not at all. Pepper Cloud CRM offers flexible pricing to suit every
          business size—from startups to enterprises. You only pay for the
          features you need, making it a cost-effective investment to streamline
          your sales, marketing, and customer support processes.
        </>
      ),
    },
    {
      question: "Which CRM is best for small business?",
      answer: (
        <>
          For small businesses, the ideal CRM should be cost-effective, easy to
          implement, and scalable as the business grows. Pepper Cloud CRM is an
          excellent choice for small businesses in India, offering a
          user-friendly interface, AI-powered automation, and seamless WhatsApp
          integration, all designed to help businesses manage leads and customer
          relationships effectively.
        </>
      ),
    },
  ];

  const compareItems = [
    "Pepper Cloud CRM",
    "HubSpot CRM",
    "Salesforce",
    "Zoho CRM",
    "Blackbaud CRM",
  ];
  const compareData = [
    {
      title: "Pepper Cloud CRM",
      desc: "Pepper Cloud CRM stands out as the premier choice for Indian businesses, offering a comprehensive suite of features tailored to the local market. This all-in-one solution combines powerful lead management, AI-powered suite, Automated workflows and WhatsApp integration, making it perfectly suited for India’s business landscape.",
      img: compareItemImg1,
      alt: "",
      features: [
        {
          title: "AI-powered suite",
          desc: "Chatbots, real-time sales assistance, and automated task flows optimise your business operations.",
        },
        {
          title: "WhatsApp CRM integration",
          desc: "Engage customers via  India’s most-used messaging platform for real-time support and marketing.",
        },
        {
          title: "Lead management",
          desc: "Capture and track leads with built-in webforms, UTM tracking, and lead source attribution.",
        },
        {
          title: "Omnichannel connectivity",
          desc: "Manage all conversations via calls, social media, emails, and messaging apps in one place.",
        },
        {
          title: "Automated workflows",
          desc: "Route leads, send reminders, and trigger actions based on time or customer behaviour.",
        },
        {
          title: "Customisable dashboards",
          desc: "Gain real-time insights with easy-to-create reports and performance metrics.",
        },
      ],
      cta: "Get demo",
    },
    {
      title: "HubSpot CRM",
      desc: "HubSpot CRM is a great choice for businesses that want to align their sales and marketing under one roof. Known for its simplicity and scalable features, it is widely used by  Indian SMEs and startups.",
      img: compareItemImg2,
      alt: "",
      features: [
        {
          title: "Pipeline builder",
          desc: "Customise your sales process with an intuitive drag-and-drop interface.",
        },
        {
          title: "Marketing automation",
          desc: "Launch and manage campaigns across email, social media, and more.",
        },
        {
          title: "Free tier",
          desc: "Start with no cost using the basic plan, ideal for small teams.",
        },
        {
          title: "Integration ecosystem",
          desc: "Connect easily with third-party tools across various categories.",
        },
      ],
    },
    {
      title: "Salesforce",
      desc: "Salesforce is a powerful CRM platform trusted by enterprises around the world, including Indian companies with complex needs. Its vast AppExchange marketplace and enterprise-level capabilities offer unmatched scalability.",
      img: compareItemImg3,
      alt: "",
      features: [
        {
          title: "AppExchange marketplace",
          desc: "Access thousands of industry-specific apps and plugins.",
        },
        {
          title: "Einstein AI",
          desc: "Use predictive AI insights to drive smarter business decisions.",
        },
        {
          title: "Customisable workflows",
          desc: "Build tailored automations for every department.",
        },
        {
          title: "Advanced reporting",
          desc: "Deep analytics and forecasting tools for detailed business evaluation.",
        },
      ],
    },
    {
      title: "Zoho CRM",
      desc: "Zoho CRM offers an affordable yet robust CRM system for small to mid-sized businesses in India. Its mobile-first design and flexible modules make it a favourite among agile teams.",
      img: compareItemImg4,
      alt: "",
      features: [
        {
          title: "Zia AI assistant",
          desc: "Leverage predictive analytics and automation for smarter sales.",
        },
        {
          title: "Multichannel communication",
          desc: "Connect with customers across phone, email, social, and chat.",
        },
        {
          title: "Customisable modules",
          desc: "Adapt the CRM to match your business flow.",
        },
        {
          title: "Gamification features",
          desc: "Boost team engagement through goals, points, and leaderboards.",
        },
      ],
    },
    {
      title: "Microsoft Dynamics 365",
      desc: "Microsoft Dynamics 365 brings enterprise-grade CRM with seamless Microsoft Office and Teams integration, ideal for  Indian companies already using the Microsoft stack.",
      img: compareItemImg5,
      alt: "",
      features: [
        {
          title: "LinkedIn integration",
          desc: "Enrich leads and improves outreach through LinkedIn Sales Navigator.",
        },
        {
          title: "Power BI integration",
          desc: "Visualise and share data insights across teams with advanced dashboards.",
        },
        {
          title: "AI-driven insights",
          desc: "Forecast trends and analyse behaviour using machine learning.",
        },
        {
          title: "Industry-specific solutions",
          desc: "Custom tools for sectors like manufacturing, retail, and finance.",
        },
      ],
    },
  ];

  const bestPractice = [
    {
      icon: smartIcon1,
      alt: "",
      heading: "AI-powered efficiency",
      desc: "Automate tasks, boost sales, and offer 24/7 support with AI chatbots, smart suggestions, and real-time sales insights.",
    },
    {
      icon: smartIcon2,
      alt: "",
      heading: "Lead management",
      desc: "Capture, assign, and track leads from WhatsApp, website forms, and Facebook—all in one CRM tailored for Indian businesses.",
    },
    {
      icon: smartIcon3,
      alt: "",
      heading: "Sales pipeline management",
      desc: "Visualise your entire sales process using multi-level pipelines and forecasting tools. Make faster, smarter decisions that drive conversions.",
    },
    {
      icon: smartIcon4,
      alt: "",
      heading: "Automated workflows",
      desc: "Automate lead routing, follow-ups, and team alerts with time-based and event-triggered actions—boosting productivity without manual effort.",
    },
    {
      icon: smartIcon5,
      alt: "",
      heading: "WhatsApp CRM",
      desc: "Engage customers on India’s top messaging app with automated replies, personalized flows, and group handling—all within the CRM.",
    },
    {
      icon: smartIcon6,
      alt: "",
      heading: "Multichannel communication",
      desc: "Connect with customers via email, WhatsApp, Facebook, Instagram, and Telegram—manage all conversations in Pepper Cloud CRM.",
    },
    {
      icon: smartIcon7,
      alt: "",
      heading: "Task and activity management",
      desc: "Assign tasks, schedule meetings, and keep follow-ups on track so your sales team stays productive and focused.",
    },
    {
      icon: smartIcon8,
      alt: "",
      heading: "Mobile CRM app",
      desc: "Empower your field teams with our mobile CRM app—stay connected, access data, and close deals from anywhere in India.",
    },
    {
      icon: smartIcon9,
      alt: "",
      heading: "CRM integrations",
      desc: "Seamlessly integrate with Google Workspace, marketing platforms, and more to build a connected CRM system for your Indian business.",
    },
  ];
  const tabContentData = [
    {
      tabContent: [
        {
          heading: "AI-powered lead capture and management",
          content:
            "Capture leads from multiple channels and nurture with AI workflows.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI-driven upselling and support",
          content:
            "Suggest products based on behaviour and offer 24/7 chatbot support.",
          alt: "E-commerce CRM",
        },
        {
          heading: "Omnichannel engagement",
          content:
            "Manage WhatsApp, email, and social media in one unified inbox.",
          alt: "E-commerce CRM",
        },
        {
          heading: "AI insights for better decision-making",
          content:
            "Use AI to track conversions and learn customer preferences.",
          alt: "E-commerce CRM",
        },
      ],
      img: realWorldImg1,
      alt: "E-commerce CRM for India",
      subtitle:
        "Drive smarter sales with AI-powered CRM, optimising customer engagement and boosting conversions for Indian e-commerce businesses.",
    },
    {
      tabContent: [
        {
          heading: "AI-driven appointment scheduling",
          content:
            "Automate bookings, rescheduling & reminders with AI workflows.",
          alt: "Healthcare CRM",
        },
        {
          heading: "AI-enhanced patient support",
          content:
            "Answer patient queries instantly with chatbots, freeing staff time.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Centralised patient communication",
          content:
            "Manage WhatsApp, email, and calls on one platform for faster replies.",
          alt: "Healthcare CRM",
        },
        {
          heading: "Data insights and compliance",
          content:
            "Securely share reports and track patient interactions with ease.",
          alt: "Healthcare CRM",
        },
      ],
      img: realWorldImg2,
      alt: "Healthcare CRM for India",
      subtitle:
        "Enhance patient care with AI-powered CRM, improving communication and reducing administrative burden for healthcare providers in India.",
    },
    {
      tabContent: [
        {
          heading: "AI-driven student support",
          content:
            "Use AssistAI to instantly answer student queries and boost engagement.",
          alt: "Education CRM",
        },
        {
          heading: "Automated academic workflows",
          content: "Schedule classes, send reminders, and track tasks with AI.",
          alt: "Education CRM",
        },
        {
          heading: "Omnichannel communication",
          content: "Communicate on WhatsApp, email, portals—all from one CRM.",
          alt: "Education CRM",
        },
        {
          heading: "AI-powered insights",
          content:
            "Track student engagement and performance for better outcomes.",
          alt: "Education CRM",
        },
      ],
      img: realWorldImg3,
      alt: "Education CRM for India",
      subtitle:
        "Improve student engagement and academic administration with AI-powered CRM for educational institutions in India.",
    },
    {
      tabContent: [
        {
          heading: "AI-enhanced lead nurturing",
          content:
            "Auto-qualify leads and send property picks with AI workflows.",
          alt: "Real Estate CRM",
        },
        {
          heading: "AI-assisted property viewing scheduling",
          content:
            "Let clients book property viewings effortlessly with AI scheduling.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Omnichannel communication",
          content:
            "Manage WhatsApp, email, and calls from one platform for easy comms.",
          alt: "Real Estate CRM",
        },
        {
          heading: "Data-driven sales insights",
          content:
            "Use AI to track sales, optimize follow-ups, and boost conversions.",
          alt: "Real Estate CRM",
        },
      ],
      img: realWorldImg4,
      alt: "Real Estate CRM for India",
      subtitle:
        "Accelerate property sales and lead nurturing with AI-driven CRM, tailored for the Indian real estate market.",
    },
  ];
  const cards = [
    {
      heading: "What is India CRM software?",
      content:
        "CRM software in India helps businesses manage customer relationships, automate workflows, and drive growth. It centralises communication, lead tracking, and sales processes in one intelligent platform.",
    },
    {
      heading: "Why Indian businesses need a CRM?",
      content:
        "A CRM helps businesses build strong customer relationships, improve communication, and streamline operations. In India’s competitive landscape, having a CRM system in place can give you the edge to grow faster and serve better.",
    },
  ];
  const adaptList = [
    {
      pointer: "All-in-one CRM",
      desc: "Pepper Cloud combines lead management and sales automation into one unified platform—no need for multiple tools.",
      img: bestIcon1,
    },
    {
      pointer: "All-size business",
      desc: "Whether you're a startup, SME or enterprise, our CRM is tailored to suit your business stage and industry.",
      img: bestIcon2,
    },
    {
      pointer: "Affordable pricing",
      desc: "Transparent and cost-effective plans with zero setup charges—built to support Malaysian SMEs and startups.",
      img: bestIcon3,
    },
    {
      pointer: "24/7 local support",
      desc: "Get round-the-clock help from our team who understands the Malaysian market and speaks your language.",
      img: bestIcon4,
    },
    {
      pointer: "Advanced customisation",
      desc: "Tailor the CRM with flexible workflows, custom fields, and pipeline stages to match your unique sales process.",
      img: bestIcon5,
    },
  ];
  const pointers = [
    "Gain complete visibility into your sales pipeline, helping your team close deals faster and smarter.",
    "Centralise all customer data in one platform to enhance collaboration and customer satisfaction.",
    "Automate repetitive tasks like follow-ups and reminders to boost your team’s productivity.",
    "Build stronger, long-lasting relationships with personalised communication and timely engagement.",
  ];
  return (
    <main>
      <SEO
        title={"Best CRM Software in India | Pepper Cloud"}
        pathname={"https://peppercloud.com/country/best-crm-software-in-india/"}
        keywords="best crm software in India,crm software India, crm system in India, crm system India, best crm India"
        description={
          "Boost your growth with the best CRM software in India. Pepper Cloud CRM helps you manage leads, automate tasks, and engage customers easily."
        }
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "Which is the best CRM software in India for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is designed specifically for SMEs in India with affordable pricing and essential features.",
                },
              },
              {
                "@type": "Question",
                name: "How to get a CRM for your growing business in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Getting started with the best CRM software in India is quick and hassle-free. Whether you’re a startup or a scaling enterprise, Pepper Cloud CRM helps you manage leads, sales, and customer relationships seamlessly.",
                },
              },
              {
                "@type": "Question",
                name: "How to choose the best CRM for your Indian business",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Scalability: Opt for a CRM that grows with your business—supporting expanding teams, leads, and customer data effortlessly. Customisation: Choose a CRM that adapts to your unique industry needs, sales pipelines, and business workflows. Integration capabilities: Ensure smooth integration with your existing tools like WhatsApp, Google Workspace, and marketing platforms. Local support: Go for a provider with dedicated support in India to ensure timely assistance and smoother onboarding. Affordable pricing: Look for a CRM that offers transparent, value-driven pricing with no hidden costs—perfect for growing Indian businesses.",
                },
              },
              {
                "@type": "Question",
                name: "How do I choose a CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Choosing the right CRM for your business involves understanding your needs and the features that best support your growth. Start by considering: Scalability: Ensure the CRM can grow with your business and handle increasing data and team size. Customisation: Look for a CRM that allows you to tailor workflows, pipelines, and dashboards to fit your business processes. Integration: Choose a CRM that integrates seamlessly with your existing tools like WhatsApp, email, Google Workspace, and social media platforms. User-Friendliness: A simple, intuitive interface is key for ensuring your team adopts the system easily. Support: Ensure the CRM offers local support for quick troubleshooting and effective onboarding.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM suitable for Indian startups?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Absolutely. It is scalable, easy to set up, and comes with automation to help startups grow faster.",
                },
              },
              {
                "@type": "Question",
                name: "Can I integrate Pepper Cloud CRM with my current tools?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Yes, it supports email, forms, calendars, and third-party tools integration.",
                },
              },
              {
                "@type": "Question",
                name: "How secure is Pepper Cloud CRM?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "It uses multi-layered security protocols to protect your customer data and ensure compliance.",
                },
              },
              {
                "@type": "Question",
                name: "Which CRM is most used in India?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "While many global CRMs are used in India, Pepper Cloud CRM is rapidly becoming the preferred choice for Indian SMEs due to its user-friendly interface, affordability, and features tailored for local business needs—like WhatsApp integration, lead tracking, and regional support.",
                },
              },
              {
                "@type": "Question",
                name: "Is Pepper Cloud CRM costly?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Not at all. Pepper Cloud CRM offers flexible pricing to suit every business size—from startups to enterprises. You only pay for the features you need, making it a cost-effective investment to streamline your sales, marketing, and customer support processes.",
                },
              },
              {
                "@type": "Question",
                name: "Which CRM is best for small business?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "For small businesses, the ideal CRM should be cost-effective, easy to implement, and scalable as the business grows. Pepper Cloud CRM is an excellent choice for small businesses in India, offering a user-friendly interface, AI-powered automation, and seamless WhatsApp integration, all designed to help businesses manage leads and customer relationships effectively.",
                },
              },
            ],
          },
        ]}
      />
      <section className={classes.heroSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h1
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-72 color-black1"
            >
              Grow faster with the best CRM software in{" "}
              <img className="countryLogo" src={india} alt="India" />{" "}
              <span className="countryHighlight">India</span>
            </motion.h1>
            <motion.p
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-inter-regular font-18 color-black2 mt10"
              //   style={{ color: "#A2BED3" }}
            >
              Pepper Cloud CRM, the best CRM software in India, helps businesses
              streamline sales, automate workflows, and deliver exceptional
              customer experiences from first touchpoint to post-sale
              engagement.
            </motion.p>
            <div className={classes.listContainer}>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  AI-driven automation
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  WhatsApp CRM engagement
                </p>
              </div>
              <div className={classes.listItem}>
                <LazyImage
                  source={greenCheckCircle}
                  alt={"pointer"}
                  className={classes.pointerImg}
                />
                <p className="font-inter-regular font-18">
                  Unified customer touchpoints
                </p>
              </div>
            </div>
            <div className="buttonContaienr mt40">
              <Link
                to="/contact/"
                className="primaryButton font-20 font-wix-medium font-white"
              >
                Book a free demo
              </Link>
            </div>
          </div>
        </div>
      </section>
      <section className={classes.countrySection}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 font-white"
            >
              A quick guide about best CRM software in India
            </motion.h2>
          </div>
          <div className="cards">
            {cards.map((card) => (
              <div className="card">
                <p className="font-24 font-wix-semibold font-white">
                  {card.heading}
                </p>
                <p className="font-wix-regular font-18 font-white">
                  {card.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-medium font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why Pepper Cloud is the best CRM software system in India
            </motion.h2>
          </div>
        </div>
        <Swiper
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          slidesPerView={3.3}
          // centeredSlides={true}
          spaceBetween={30}
          grabCursor={true}
          loop={true}
          speed={5000}
          modules={[Autoplay]}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  alt={point.pointer}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.growingBusiness}>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Sell smarter and scale faster with India’s top CRM solution.
            </motion.h2>
          </div>
          <div className="body">
            {bestPractice.map((practice) => (
              <div className={classes.practiceCard}>
                <img src={practice.icon} alt={practice.heading} />
                <p className="font-wix-semibold font-24 font-white">
                  {practice.heading}
                </p>
                <p
                  className="font-wix-medium font-16"
                  style={{ color: "#E9F4FE" }}
                >
                  {practice.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className={classes.absoulteCard}>
          {/* <TruestedSection background={true} /> */}
        </div>
      </section>
      <section className={classes.tabsSection}>
        <div className="container">
          <motion.div
            initial={{ opacity: 1, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
            className={classes.supportBox}
            // style={{ background: point.background }}
          >
            <div className={classes.broadcastLeftContainer}>
              <p className="font-40 font-wix-regular font-white">
                Benefits of using a CRM tool for your Indian growing business
              </p>
              <div className={classes.pointers}>
                {pointers.map((pointer) => (
                  <div className={classes.cardPointer}>
                    <LazyImage
                      source={whiteCheckCircle}
                      className={classes.pointerImg}
                      alt={"pointer"}
                    />
                    <p className="font-inter-regular font-18 font-white">
                      {pointer}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.broadcastRightContainer}>
              <LazyImage
                source={benefitImg}
                alt={
                  " Benefits of using a CRM tool for your Indian growing business"
                }
                className={classes.broadcastImg}
              />
            </div>
          </motion.div>
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-56 color-black1"
            >
              Applications and use cases of India CRM software
            </motion.h2>
            <div className={classes.tabsContainer}>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 0 && "active"
                )}
                onClick={() => setActiveRealWorld(0)}
              >
                E-commerce
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 1 && "active"
                )}
                onClick={() => setActiveRealWorld(1)}
              >
                Healthcare
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 2 && "active"
                )}
                onClick={() => setActiveRealWorld(2)}
              >
                Education
              </div>
              <div
                className={clsx(
                  classes.tab,
                  "font-wix-medium",
                  "font-20",
                  activeRealWorld === 3 && "active"
                )}
                onClick={() => setActiveRealWorld(3)}
              >
                Real Estate
              </div>
            </div>
          </div>
          <div className={classes.tabCard}>
            <div className={classes.tabCardLeftContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <div>
                      <motion.p
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                        className="font-wix-regular font-18 color-black2"
                      >
                        {listItem.subtitle}
                      </motion.p>
                      <div className={classes.benfitListContainer}>
                        {listItem.tabContent.map((item) => (
                          <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.3 }}
                            className={classes.benfitListItem}
                          >
                            <LazyImage
                              source={greenCheckCircle}
                              className={classes.benfitIcon}
                              alt={item.alt}
                            />
                            <div className={classes.benfitListItemContent}>
                              <p className="font-wix-semibold font-20 color-black1">
                                {item.heading}
                              </p>
                              <p className="font-wix-regular font-16 color-black2">
                                {item.content}
                              </p>
                            </div>
                          </motion.div>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            <div className={classes.tabCardRightContainer}>
              {tabContentData.map(
                (listItem, index) =>
                  index === activeRealWorld && (
                    <motion.div
                      initial={{ opacity: 1, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.3 }}
                      // className={classes.aiSectionRight}
                    >
                      <LazyImage
                        source={listItem.img}
                        alt={listItem.alt}
                        width={"100%"}
                      />
                    </motion.div>
                  )
              )}
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="container">
          <div className="header">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-black1"
            >
              5 best CRM software in India
            </motion.h2>
          </div>
          <div className={classes.compareSectionContainer}>
            <div className={classes.compareSectionContainerLeftSection}>
              {compareItems.map((item, index) => (
                <div
                  className={clsx(
                    classes.compareSectionLeftItem,
                    activeCompare === `#section${index}` && "active"
                  )}
                  onClick={() => {
                    scrollToSection(`#section${index}`);
                    setActiveCompare(`#section${index}`);
                  }}
                >
                  <a
                    href={`#section${index}`}
                    className={clsx(
                      "font-22 font-wix-medium font-black1",
                      activeCompare === `#section${index}` && "font-wix-bold"
                    )}
                  >
                    {item}
                  </a>
                </div>
              ))}
            </div>
            <div className={classes.compareSectionContainerRightSection}>
              {compareData.map((data, outerIndex) => (
                <div
                  className={classes.compareItemContainer}
                  id={`#section${outerIndex}`}
                >
                  <h3
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-40 font-wix-semibold font-black1"
                  >
                    {data.title}
                  </h3>
                  <p
                    initial={{ opacity: 1, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="font-inter-regular font-18 font-black1"
                  >
                    {data.desc}
                  </p>
                  <img src={data.img} className="productImage" alt={data.alt} />
                  <div className={classes.faqsContainer}>
                    {data.features.map((faq, innerIndex) => (
                      <motion.div
                        whileInView={{ opacity: [0, 1], y: [50, 0] }}
                        transition={{ duration: 1, delay: innerIndex * 0.01 }}
                        className={classes.faqBox}
                        onClick={() =>
                          setActiveAccordian(
                            `${outerIndex}-${innerIndex}` === activeAccordian
                              ? -1
                              : `${outerIndex}-${innerIndex}`
                          )
                        }
                      >
                        <div className={classes.header}>
                          <h3 className="font-20 font-wix-semibold">
                            {faq.title}
                          </h3>
                          <img
                            src={downArrow}
                            alt="Arrow"
                            className={clsx(
                              classes.downArrow,
                              `${outerIndex}-${innerIndex}` ===
                                activeAccordian && "active"
                            )}
                          />
                        </div>
                        <Collapse
                          className={classes.body}
                          in={activeAccordian === `${outerIndex}-${innerIndex}`}
                        >
                          <p className="font-18 font-inter-regular color-black2">
                            {faq.desc}
                          </p>
                        </Collapse>
                      </motion.div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <TruestedSection />

      <section className={classes.stripSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h3
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-semibold font-24 font-black1"
            >
              Best CRM with WhatsApp integration - Trusted by SMEs globally
            </motion.h3>
          </div>
        </div>
        <Swiper
          className={classes.partnerSlider}
          slidesPerView="auto"
          spaceBetween={60}
          loop={true}
          speed={3000}
          modules={[Autoplay]}
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              freeMode: true,
              grabCursor: false,
              allowTouchMove: true,
              spaceBetween: 20,
            },
            // For larger screens (desktop)
            768: {
              freeMode: false,
              autoplay: {
                delay: 100,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              },
              speed: 3000,
              loop: true,
              allowTouchMove: true,
            },
          }}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img src={partner.icon} alt={partner.alt} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <div className={classes.testimonials}>
        <TestimonialSlider
          noButton={true}
          heading={"Real stories. Real results."}
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
        />
      </div>
      <AllCountries />
      <div className={classes.wpFaq}>
        <FaqSection
          backgroundColor={"#eaffff"}
          heading={"FAQs - Best CRM software in India"}
          faqs={faqs}
        />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              initial={{ opacity: 1, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              className="font-wix-medium font-56 font-white"
            >
              Sell smarter and scale faster with India’s top CRM solution.
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/"
            >
              Book a free demo
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default India;
